// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deicing-check-form {
    max-width: 1100px;
    margin: 0 auto;
    padding: 24px;
    font-family: Arial, sans-serif;

    /* .form-section {
    margin-bottom: 24px;
    padding: 20px;
    border: 1px solid #d7d7d7;
    border-radius: 8px;
  } */

    /* .form-section h2 {
    margin-top: 0;
    font-size: 18px;
  } */

    .form-section {
        padding: 18px;
        border: 1px solid #d5ddeb;
        border-radius: 12px;
        background: white;
        margin-bottom: 24px;
    }

    .form-section h3 {
        margin:
            -18px
            /* top */
            -18px
            /* right */
            18px
            /* bottom */
            -18px;
        /* left */

        padding: 8px 20px;

        background: rgba(1, 56, 104, 0.9);
        color: white;

        border-radius: 5px 5px 0 0;

        font-weight: unset;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
    }

    label {
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-weight: 600;
    }

    input,
    select,
    textarea {
        box-sizing: border-box;
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #bdbdbd;
        border-radius: 4px;
        font: inherit;
    }

    input[readonly] {
        background: #f3f3f3;
    }

    /* .date-time-field {
    display: flex;
    align-items: flex-end;
    gap: 8px;
  }

  .date-time-field label {
    flex: 1;
  }

  .date-time-field button {
    min-height: 41px;
  } */

    .checkbox-field {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0px;
        padding-top: 15px;
    }

    /* .checkbox-field input[type="checkbox"] {
    margin: 0;
    flex-shrink: 0;
  } */

    .checkbox-field input[type="checkbox"] {
        width: 40px;
        height: 20px;
        transform: scale(1.4);
        cursor: pointer;
        font-size: larger;
        margin-left: -4px;
        margin-bottom: 5px;
    }

    /* .checkbox-field {
    flex-direction: row;
    align-items: center;
    align-self: end;
    min-height: 41px;
  }

  .checkbox-field input {
    width: auto;
  } */

    .form-actions {
        display: flex;
        justify-content: flex-end;
    }

    button {
        padding: 10px 16px;
        border: 0;
        border-radius: 4px;
        cursor: pointer;
    }

    .form-actions button {
        font-weight: 600;
    }

    .date-time-field {
        display: grid;
        grid-template-columns: minmax(220px, 1fr) auto;
        align-items: end;
        gap: 12px;
        width: 100%;
        min-width: 0;
    }

    .date-time-field__label {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0;
    }

    .date-time-field__label-text {
        font-size: 15px;
        font-weight: 500;
    }

    .date-time-field__input {
        width: 100%;
        min-width: 0;
        height: 44px;
        padding: 0 12px;
        box-sizing: border-box;
        font: inherit;
    }

    .date-time-field__button {
        min-height: 44px;
        padding: 0 16px;
        white-space: nowrap;
        cursor: pointer;
    }

    /* Tablet */
    @media (max-width: 1199px) {
        .date-time-field {
            grid-template-columns: minmax(190px, 1fr) auto;
            gap: 8px;
        }

        .date-time-field__input {
            height: 46px;
        }

        .date-time-field__button {
            min-height: 46px;
            padding: 0 12px;
            font-size: 14px;
        }
    }

    /* Mobile */
    @media (max-width: 700px) {

        .form-grid {
            grid-template-columns: 1fr;
        }

        .date-time-field {
            grid-template-columns: 1fr;
            align-items: stretch;
            gap: 8px;
        }

        .date-time-field__label {
            width: 100%;
        }

        .date-time-field__input {
            width: 100%;
            min-height: 48px;
            padding: 0 10px;
            font-size: 16px;
        }

        .date-time-field__button {
            width: 100%;
            min-height: 48px;
            padding: 0 12px;
            white-space: normal;
            font-size: 15px;
        }
    }

    /* @media (max-width: 700px) {
    .form-grid {
      grid-template-columns: 1fr;
    }

    .date-time-field {
      align-items: stretch;
      flex-direction: column;
    }
  } */

    .wheatherConditions {
        margin-top: 20px;
    }

    .input-with-button {
        display: flex;
        gap: 8px;
        width: 100%;
    }

    .input-with-button input {
        flex: 1;
        min-width: 0;
    }

    .input-with-button button {
        flex-shrink: 0;
        padding: 0 16px;
        cursor: pointer;
        color: white;
        font-size: large;
        background: rgba(1, 56, 104, 0.9);
    }

    .form-action-field {
        display: flex;
        align-items: flex-end;
    }

    .form-action-button {
        width: 100%;
        min-height: 41px;
        cursor: pointer;
        color: white;
        font-size: larger;
        background: rgba(1, 56, 104, 0.9);
    }

    .form-action-button-plus {
        min-height: 41px;
        cursor: pointer;
        color: white;
        font-size: large;
        font-weight: bold;
        background: rgba(1, 56, 104, 0.9);
        margin-top: 20px;
    }

    /* .form-action-link {
    padding: 10px 0;
    border: none;
    background: none;
    color: #0066cc;
    text-decoration: underline;
    font: inherit;
    cursor: pointer;
    font-size: large;
  }

  .form-action-link:hover {
    text-decoration: none;
  } */

    .toggle {
        display: inline-flex;
        border: 1px solid #ccc;
        border-radius: 6px;
        overflow: hidden;
    }

    .toggle button {
        padding: 8px 16px;
        border: none;
        background: white;
        cursor: pointer;
        font-size: larger
    }

    .toggle button.active {
        background: rgba(1, 56, 104, 0.9);
        color: white;
    }

    .ratio-input {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .ratio-input input {
        flex: 1;
        min-width: 0;
    }

    .ratio-input span {
        font-size: 20px;
        font-weight: 500;
    }

    .deice-item {
        margin-top: 20px;
    }

    .deicing-summary {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .deicing-summary-item {
        border: 1px solid #d9e0e6;
        border-radius: 8px;
        overflow: hidden;
        background: #fff;
    }

    .deicing-summary-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        background: #f3f6f8;
        border-bottom: 1px solid #d9e0e6;
        font-size: 15px;
    }

    .deicing-summary-header span {
        font-weight: 600;
    }

    .deicing-stage {
        padding: 16px;
    }

    .deicing-stage+.deicing-stage {
        border-top: 1px solid #d9e0e6;
    }

    .deicing-stage h4 {
        margin: 0 0 12px;
        font-size: 16px;
        color: #013868;
    }

    .summary-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px 24px;
        margin-bottom: 12px;
    }

    .summary-value {
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    .summary-value span {
        font-size: 13px;
        color: #66737f;
    }

    .summary-value strong {
        font-size: 15px;
        color: #202830;
    }

    .deicing-fluid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
        padding: 12px;
        margin-top: 8px;
        background: #f7f9fa;
        border-radius: 6px;
    }

    @media (max-width: 768px) {

        .summary-grid,
        .deicing-fluid {
            grid-template-columns: 1fr;
        }
    }

    .check-text {
        margin-top: 20px;
        font-size: smaller;
    }

    .validation-warning {
        /* padding: 10px 12px; */
        /* margin-top: 22px; */
        /* border: 1px solid #d97706;
    background: #fff7ed; */
        color: red;
        /* border-radius: 6px; */
        font-size: 14px;
    }
}

/**/`, "",{"version":3,"sources":["webpack://./src/web/component/DeicingCheck/styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;;IAE9B;;;;;KAKC;;IAED;;;KAGC;;IAED;QACI,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI;;;;;;;iBAOS;QACT,SAAS;;QAET,iBAAiB;;QAEjB,iCAAiC;QACjC,YAAY;;QAEZ,0BAA0B;;QAE1B,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gDAAgD;QAChD,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;;;QAGI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;;;;;;;;;;KAYC;;IAED;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;QACR,iBAAiB;IACrB;;IAEA;;;KAGC;;IAED;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;;;;;;;;;KASC;;IAED;QACI,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8CAA8C;QAC9C,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,eAAe;IACnB;;IAEA,WAAW;IACX;QACI;YACI,8CAA8C;YAC9C,QAAQ;QACZ;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,gBAAgB;YAChB,eAAe;YACf,eAAe;QACnB;IACJ;;IAEA,WAAW;IACX;;QAEI;YACI,0BAA0B;QAC9B;;QAEA;YACI,0BAA0B;YAC1B,oBAAoB;YACpB,QAAQ;QACZ;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,WAAW;YACX,gBAAgB;YAChB,eAAe;YACf,eAAe;QACnB;;QAEA;YACI,WAAW;YACX,gBAAgB;YAChB,eAAe;YACf,mBAAmB;YACnB,eAAe;QACnB;IACJ;;IAEA;;;;;;;;;KASC;;IAED;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,OAAO;QACP,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iCAAiC;QACjC,gBAAgB;IACpB;;IAEA;;;;;;;;;;;;;KAaC;;IAED;QACI,oBAAoB;QACpB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,iCAAiC;QACjC,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,OAAO;QACP,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,kBAAkB;QAClB,mBAAmB;QACnB,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,gDAAgD;QAChD,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,gDAAgD;QAChD,SAAS;QACT,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;;QAEI;;YAEI,0BAA0B;QAC9B;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB;0BACkB;QAClB,UAAU;QACV,wBAAwB;QACxB,eAAe;IACnB;AACJ;;AAEA,GAAG","sourcesContent":[".deicing-check-form {\r\n    max-width: 1100px;\r\n    margin: 0 auto;\r\n    padding: 24px;\r\n    font-family: Arial, sans-serif;\r\n\r\n    /* .form-section {\r\n    margin-bottom: 24px;\r\n    padding: 20px;\r\n    border: 1px solid #d7d7d7;\r\n    border-radius: 8px;\r\n  } */\r\n\r\n    /* .form-section h2 {\r\n    margin-top: 0;\r\n    font-size: 18px;\r\n  } */\r\n\r\n    .form-section {\r\n        padding: 18px;\r\n        border: 1px solid #d5ddeb;\r\n        border-radius: 12px;\r\n        background: white;\r\n        margin-bottom: 24px;\r\n    }\r\n\r\n    .form-section h3 {\r\n        margin:\r\n            -18px\r\n            /* top */\r\n            -18px\r\n            /* right */\r\n            18px\r\n            /* bottom */\r\n            -18px;\r\n        /* left */\r\n\r\n        padding: 8px 20px;\r\n\r\n        background: rgba(1, 56, 104, 0.9);\r\n        color: white;\r\n\r\n        border-radius: 5px 5px 0 0;\r\n\r\n        font-weight: unset;\r\n    }\r\n\r\n    .form-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(2, minmax(0, 1fr));\r\n        gap: 16px;\r\n    }\r\n\r\n    label {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 6px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    input,\r\n    select,\r\n    textarea {\r\n        box-sizing: border-box;\r\n        width: 100%;\r\n        padding: 10px 12px;\r\n        border: 1px solid #bdbdbd;\r\n        border-radius: 4px;\r\n        font: inherit;\r\n    }\r\n\r\n    input[readonly] {\r\n        background: #f3f3f3;\r\n    }\r\n\r\n    /* .date-time-field {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    gap: 8px;\r\n  }\r\n\r\n  .date-time-field label {\r\n    flex: 1;\r\n  }\r\n\r\n  .date-time-field button {\r\n    min-height: 41px;\r\n  } */\r\n\r\n    .checkbox-field {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        gap: 0px;\r\n        padding-top: 15px;\r\n    }\r\n\r\n    /* .checkbox-field input[type=\"checkbox\"] {\r\n    margin: 0;\r\n    flex-shrink: 0;\r\n  } */\r\n\r\n    .checkbox-field input[type=\"checkbox\"] {\r\n        width: 40px;\r\n        height: 20px;\r\n        transform: scale(1.4);\r\n        cursor: pointer;\r\n        font-size: larger;\r\n        margin-left: -4px;\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    /* .checkbox-field {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    align-self: end;\r\n    min-height: 41px;\r\n  }\r\n\r\n  .checkbox-field input {\r\n    width: auto;\r\n  } */\r\n\r\n    .form-actions {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n    }\r\n\r\n    button {\r\n        padding: 10px 16px;\r\n        border: 0;\r\n        border-radius: 4px;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .form-actions button {\r\n        font-weight: 600;\r\n    }\r\n\r\n    .date-time-field {\r\n        display: grid;\r\n        grid-template-columns: minmax(220px, 1fr) auto;\r\n        align-items: end;\r\n        gap: 12px;\r\n        width: 100%;\r\n        min-width: 0;\r\n    }\r\n\r\n    .date-time-field__label {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 6px;\r\n        min-width: 0;\r\n    }\r\n\r\n    .date-time-field__label-text {\r\n        font-size: 15px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .date-time-field__input {\r\n        width: 100%;\r\n        min-width: 0;\r\n        height: 44px;\r\n        padding: 0 12px;\r\n        box-sizing: border-box;\r\n        font: inherit;\r\n    }\r\n\r\n    .date-time-field__button {\r\n        min-height: 44px;\r\n        padding: 0 16px;\r\n        white-space: nowrap;\r\n        cursor: pointer;\r\n    }\r\n\r\n    /* Tablet */\r\n    @media (max-width: 1199px) {\r\n        .date-time-field {\r\n            grid-template-columns: minmax(190px, 1fr) auto;\r\n            gap: 8px;\r\n        }\r\n\r\n        .date-time-field__input {\r\n            height: 46px;\r\n        }\r\n\r\n        .date-time-field__button {\r\n            min-height: 46px;\r\n            padding: 0 12px;\r\n            font-size: 14px;\r\n        }\r\n    }\r\n\r\n    /* Mobile */\r\n    @media (max-width: 700px) {\r\n\r\n        .form-grid {\r\n            grid-template-columns: 1fr;\r\n        }\r\n\r\n        .date-time-field {\r\n            grid-template-columns: 1fr;\r\n            align-items: stretch;\r\n            gap: 8px;\r\n        }\r\n\r\n        .date-time-field__label {\r\n            width: 100%;\r\n        }\r\n\r\n        .date-time-field__input {\r\n            width: 100%;\r\n            min-height: 48px;\r\n            padding: 0 10px;\r\n            font-size: 16px;\r\n        }\r\n\r\n        .date-time-field__button {\r\n            width: 100%;\r\n            min-height: 48px;\r\n            padding: 0 12px;\r\n            white-space: normal;\r\n            font-size: 15px;\r\n        }\r\n    }\r\n\r\n    /* @media (max-width: 700px) {\r\n    .form-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    .date-time-field {\r\n      align-items: stretch;\r\n      flex-direction: column;\r\n    }\r\n  } */\r\n\r\n    .wheatherConditions {\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .input-with-button {\r\n        display: flex;\r\n        gap: 8px;\r\n        width: 100%;\r\n    }\r\n\r\n    .input-with-button input {\r\n        flex: 1;\r\n        min-width: 0;\r\n    }\r\n\r\n    .input-with-button button {\r\n        flex-shrink: 0;\r\n        padding: 0 16px;\r\n        cursor: pointer;\r\n        color: white;\r\n        font-size: large;\r\n        background: rgba(1, 56, 104, 0.9);\r\n    }\r\n\r\n    .form-action-field {\r\n        display: flex;\r\n        align-items: flex-end;\r\n    }\r\n\r\n    .form-action-button {\r\n        width: 100%;\r\n        min-height: 41px;\r\n        cursor: pointer;\r\n        color: white;\r\n        font-size: larger;\r\n        background: rgba(1, 56, 104, 0.9);\r\n    }\r\n\r\n    .form-action-button-plus {\r\n        min-height: 41px;\r\n        cursor: pointer;\r\n        color: white;\r\n        font-size: large;\r\n        font-weight: bold;\r\n        background: rgba(1, 56, 104, 0.9);\r\n        margin-top: 20px;\r\n    }\r\n\r\n    /* .form-action-link {\r\n    padding: 10px 0;\r\n    border: none;\r\n    background: none;\r\n    color: #0066cc;\r\n    text-decoration: underline;\r\n    font: inherit;\r\n    cursor: pointer;\r\n    font-size: large;\r\n  }\r\n\r\n  .form-action-link:hover {\r\n    text-decoration: none;\r\n  } */\r\n\r\n    .toggle {\r\n        display: inline-flex;\r\n        border: 1px solid #ccc;\r\n        border-radius: 6px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .toggle button {\r\n        padding: 8px 16px;\r\n        border: none;\r\n        background: white;\r\n        cursor: pointer;\r\n        font-size: larger\r\n    }\r\n\r\n    .toggle button.active {\r\n        background: rgba(1, 56, 104, 0.9);\r\n        color: white;\r\n    }\r\n\r\n    .ratio-input {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        width: 100%;\r\n    }\r\n\r\n    .ratio-input input {\r\n        flex: 1;\r\n        min-width: 0;\r\n    }\r\n\r\n    .ratio-input span {\r\n        font-size: 20px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .deice-item {\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .deicing-summary {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 16px;\r\n    }\r\n\r\n    .deicing-summary-item {\r\n        border: 1px solid #d9e0e6;\r\n        border-radius: 8px;\r\n        overflow: hidden;\r\n        background: #fff;\r\n    }\r\n\r\n    .deicing-summary-header {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n        padding: 12px 16px;\r\n        background: #f3f6f8;\r\n        border-bottom: 1px solid #d9e0e6;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .deicing-summary-header span {\r\n        font-weight: 600;\r\n    }\r\n\r\n    .deicing-stage {\r\n        padding: 16px;\r\n    }\r\n\r\n    .deicing-stage+.deicing-stage {\r\n        border-top: 1px solid #d9e0e6;\r\n    }\r\n\r\n    .deicing-stage h4 {\r\n        margin: 0 0 12px;\r\n        font-size: 16px;\r\n        color: #013868;\r\n    }\r\n\r\n    .summary-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(2, minmax(0, 1fr));\r\n        gap: 12px 24px;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    .summary-value {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 3px;\r\n    }\r\n\r\n    .summary-value span {\r\n        font-size: 13px;\r\n        color: #66737f;\r\n    }\r\n\r\n    .summary-value strong {\r\n        font-size: 15px;\r\n        color: #202830;\r\n    }\r\n\r\n    .deicing-fluid {\r\n        display: grid;\r\n        grid-template-columns: repeat(3, minmax(0, 1fr));\r\n        gap: 16px;\r\n        padding: 12px;\r\n        margin-top: 8px;\r\n        background: #f7f9fa;\r\n        border-radius: 6px;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n\r\n        .summary-grid,\r\n        .deicing-fluid {\r\n            grid-template-columns: 1fr;\r\n        }\r\n    }\r\n\r\n    .check-text {\r\n        margin-top: 20px;\r\n        font-size: smaller;\r\n    }\r\n\r\n    .validation-warning {\r\n        /* padding: 10px 12px; */\r\n        /* margin-top: 22px; */\r\n        /* border: 1px solid #d97706;\r\n    background: #fff7ed; */\r\n        color: red;\r\n        /* border-radius: 6px; */\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n/**/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
